// 헤더 좌슬롯(#dash-header-slot-left) 포털 — 타이틀 옆. 보통 HeaderTabs 를 넣는다.
// props: children
import React from 'react';
import SlotPortal from './SlotPortal';

function HeaderLeft(props) {
  return <SlotPortal id="dash-header-slot-left">{props.children}</SlotPortal>;
}

export default HeaderLeft;
